export default import.meta.ROLLUP_FILE_URL_0PgJxXqjw$KAl6PgZjQb5g;